import { isNativeApp } from '@/shared/utils/nativeBridge';
import { downloadFile, isLocalFileUrl } from './downloadFile';
import { openRemoteUrl } from './openRemoteUrl';

/**
 * Opens a link that is not a download (WhatsApp, a government site, a document in
 * the browser). Returns whether something was opened, as `window.open` callers expect.
 *
 * Inside the native app it goes to the system browser through the bridge, which is
 * safe after an await (binaries without the bridge get a navigation their shell turns
 * into the same hand-off, or a toast asking to update; see `openRemoteUrl`); a local
 * `blob:` file can't be opened from the WebView, so it is handed off like a download.
 * Everywhere else it is a new tab.
 *
 * Outside the app, call it straight from the click handler with nothing awaited
 * before: Safari drops the tap's user activation after any await and blocks the tab.
 */
export const openExternalUrl = (url: string): boolean => {
  if (isNativeApp() && isLocalFileUrl(url)) {
    void downloadFile({ url });
    return true;
  }
  return openRemoteUrl(url);
};
